import React, { memo, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs';
import { createSelector } from 'reselect';
import CardIndex from '../../card/CardIndex/CardIndex';
import styles from './NSpecial.module.less';

import { setSpecialZan } from '../../actions/special';
import { addCollectSpecial, deleteCollectSpecial } from '../../actions/collection';
import { logging } from '../../actions/log';
import Toast from '../../components/Toast/Toast';
import Overview from './Overview';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../config';
// import { useInView } from 'react-intersection-observer';
import { getSpecialInfo } from '../../actions/special';
import CommentList from '../../components/Comment/CommentList';
import Comment from '../../components/Comment/Comment';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

export default memo(({ recommZT, specialInfo = {}, bannerId, viewPage, ztId, bizInfo }) => {
  const [zan, setZan] = useState(false);
  const [zanNum, setZanNum] = useState(0);
  const [isCollect, setIsCollect] = useState(false); // 是否有正在提交的收藏
  const [loginStatus, setLoginStatus] = useState(false);
  const [commentEl, setCommentEl] = useState(null);
  const [collectPosition, setCollectPosition] = useState('top');
  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);
  const dispatch = useDispatch();
  const history = useHistory();
  // const [overviewVisible, setOverviewVisible] = useState(true);
  const init = useRef(null);

  // const [ref, inView] = useInView({
  //   threshold: 1,
  // });
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setOverviewVisible(!inView);
  //     clearTimeout(timer);
  //   }, 300);
  // }, [inView]);

  // 收藏专题 或则取消专题
  const handleSpecialCollect = () => {
    setIsCollect(true);
    if (!loginStatus) {
      // 调用登陆
      // eslint-disable-next-line no-unused-expressions
      window.CallNativeMethod && window.CallNativeMethod('login'); // 未登录 调用登录弹窗
      return;
    }
    setIsCollect(false);
    if (!specialInfo.hasCollect) {
      dispatch(
        addCollectSpecial({
          targetId: specialInfo.ztId,
          targetType: 'zt',
        }),
      );
      dispatch(
        logging({
          category: 'C',
          action: 'Special_Collect',
          label: '',
          param2: {
            source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: collectPosition, // 收藏点击位置
          },
          param3: bizInfo,
        }),
      );
    } else {
      dispatch(
        deleteCollectSpecial({
          targetId: specialInfo.ztId,
          targetType: 'zt',
        }),
      );
      dispatch(
        logging({
          category: 'C',
          action: 'Mysofts_Collect_Cancel',
          label: '',
          param2: {
            source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: specialInfo && specialInfo.ztId,
            softtype: 'zt',
            type: collectPosition, // 收藏点击位置
          },
          param3: bizInfo,
        }),
      );
    }
  };
  // 写入登录状态
  useEffect(() => {
    const userId = window.CallNativeMethod && window.CallNativeMethod('get_user_id');
    const loginST = window.CallNativeMethod && window.CallNativeMethod('get_st');
    if (loginST !== '' && userId) {
      // 登录
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
    // 登陆状态变化，重新获取数据
    if (init.current === true) {
      dispatch(getSpecialInfo({ ztId, viewPage }));
    }
    init.current = true;
  }, [userInfo]);
  useEffect(() => {
    if (loginStatus && isCollect) {
      handleSpecialCollect();
    }
  }, [loginStatus, isCollect]);

  // 监听滚动
  useEffect(() => {
    const img = document.getElementsByClassName('detail_img');
    if (img && img[0]) {
      img[0].style.top = `0px`;
      img[0].style.opacity = 1;
    }
  }, [specialInfo]);
  useEffect(() => {
    return () => {
      const img = document.getElementsByClassName('detail_img');
      if (img && img[0]) {
        img[0].style.top = `0px`;
        img[0].style.opacity = 1;
      }
    };
  }, []);
  useEffect(() => {
    const el = document.getElementById('container_content');
    const handleScroll = () => {
      const img = document.getElementsByClassName('detail_img');
      if (img && img[0]) {
        img[0].style.position = 'relative';
        img[0].style.top = `-${el.scrollTop}px`;
        img[0].style.opacity = 1 - (el.scrollTop / 220 > 0.9 ? 1 : el.scrollTop / 220);
      }
    };
    if (el) {
      el.addEventListener('scroll', handleScroll);
    }
    return () => {
      el.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    setZanNum(specialInfo.zanCount);
    setZan(specialInfo.hasZan === 1);
  }, [specialInfo]);

  const handleZan = source => () => {
    if (zan) {
      Toast.error({
        content: <div className={styles.toast}>已赞过该专题</div>,
        className: styles.toast_img,
      });
      return;
    }
    setZan(true);
    dispatch(
      setSpecialZan({
        type: 2,
        ztId: specialInfo.ztId,
      }),
    );
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Special_Zan',
        label: '',
        param2: {
          source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: source,
        },
        param3: bizInfo,
      }),
    );
  };

  const handleNumber = (data = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+data)) {
      return data;
    }
    if (+data < 1000) {
      return data;
    }
    if (+data < 10000) {
      return `${(data / 1000).toFixed(1)}k`;
    }

    return `${(data / 10000).toFixed(1)}w`;
  };

  const handleTag = (tag = {}) => () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Special_Classify',
        label: '',
        param2: {
          source: `Special||${specialInfo.ztId || ''}||${bannerId || ''}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: specialInfo.ztId,
          type: tag.tagId,
        },
        param3: bizInfo,
      }),
    );
    history.push(`${CONTEXT}/speciallist?pageType=special&ztType=${'all'}&tag=${tag.tagId || ''}`);
  };

  return (
    <div className={styles.nspecial}>
      <div className={styles.nspecial_container}>
        <div className={styles.nspecial_header}>
          <div className={styles.nspecial_header_content}>
            <div className={styles.nspecial_header_title}>{specialInfo.ztTitle}</div>
            <div className={styles.nspecial_header_icon}>
              <div className={classNames(styles.nspecial_header_time)}>
                {specialInfo.pushTime && dayjs(specialInfo.pushTime).format('YYYY/MM/DD')}
              </div>
              <div className={classNames(styles.nspecial_header_icon_single)}>
                <div className={classNames(styles.icon_zan)}>
                  <i
                    className={classNames('iconfont icon-reads')}
                    style={{ position: 'relative', top: '1px' }}
                  />
                </div>
                <span>{handleNumber(specialInfo.watchCount)}</span>
              </div>
              <div
                className={classNames(
                  styles.nspecial_header_icon_single,
                  styles.nspecial_header_icon_active,
                )}
                onClick={handleZan('top')}
              >
                <div className={classNames(styles.icon_zan, { [styles.icon_zan_active]: true })}>
                  <i
                    className={classNames(`iconfont ${zan ? 'icon-zaned' : 'icon-zan'}`)}
                    style={{ position: 'relative', top: '1px' }}
                  />
                </div>
                <span className={styles.text_zan}>{handleNumber(zanNum)}</span>
              </div>
              <div
                className={classNames(
                  styles.nspecial_header_icon_single,
                  styles.nspecial_header_icon_active,
                )}
                onClick={() => {
                  setCollectPosition('top');
                  handleSpecialCollect();
                }}
              >
                <div className={classNames(styles.icon_zan, { [styles.icon_zan_active]: true })}>
                  <i
                    className={classNames(
                      `iconfont ${specialInfo.hasCollect ? 'icon-collected' : 'icon-collect'}`,
                      styles.icon_collect,
                    )}
                  ></i>
                </div>
                <span className={styles.text_zan}>收藏</span>
              </div>
            </div>

            <div
              className={styles.nspecial_header_desc}
              dangerouslySetInnerHTML={{ __html: specialInfo.ztLongDesc }}
            />
          </div>
        </div>
        <div className={styles.nspecial_content}>
          {specialInfo &&
            specialInfo.ztList &&
            specialInfo.ztList.slice(1).map((item, i) => (
              <React.Fragment key={i}>
                <CardIndex data={item} key={i} logInfo={{ tag: 'Special' }} />
              </React.Fragment>
            ))}
        </div>
        {specialInfo && specialInfo.tags && specialInfo.tags.length > 0 && (
          <div className={styles.nspecial_tag}>
            <div className={styles.nspecial_tag_label}>专题标签：</div>
            {specialInfo.tags.map((item, index) => (
              <div
                className={styles.nspecial_tag_item}
                key={`${index}_${item.tagId}`}
                onClick={handleTag(item)}
              >
                {item.tagName}
              </div>
            ))}
          </div>
        )}
        {specialInfo &&
          specialInfo.ztId &&
          specialInfo.ztType &&
          recommZT &&
          recommZT.map((item, index) => {
            return (
              <CardIndex
                data={{ ...item, ztType: specialInfo.ztType || '' }}
                key={index}
                logInfo={{ tag: 'Special' }}
              />
            );
          })}
        <div>
          <div className={styles.comment} ref={r => setCommentEl(r)}>
            <div>
              <Comment
                commentId={specialInfo && specialInfo.ztCommentId}
                relaseId={specialInfo && specialInfo.ztId}
                type={2}
                logInfo={{ source: 'Special' }}
              />
            </div>
          </div>

          <CommentList
            relaseId={specialInfo && specialInfo.ztId}
            commentId={specialInfo && specialInfo.ztCommentId}
            scrollEl={document.getElementById('container_content')}
            type={2}
            logInfo={{ source: 'Special' }}
          />
        </div>
      </div>
      {
        <Overview
          specialInfo={specialInfo}
          zan={zan}
          handel={{
            collect: () => {
              setCollectPosition('suspen');
              handleSpecialCollect();
            },
            zan: handleZan('suspen'),
            comment: commentEl,
          }}
        />
      }
    </div>
  );
});
